// Generated by ts-to-zod
import { z } from 'zod';

export const contentSelectPayloadSchema = z.object({
  rectangle: z.tuple([z.number(), z.number(), z.number(), z.number()]),
  page: z.string(),
});
